<script>
  import { asteroid, Subscriber, observable } from "@/meteor.js";
    import Modal from "@/components/Modal.svelte";
  import Orders from './_orders.svelte'
  import { Customer } from "./customerModel.js";
  import { diffedJson } from "@/utils";
  export let route, url, currentOrder, statusOptionsObj;
  const { id } = route.params;
  let form = {};
  const customer = observable("customers", id);

  $: changes = diffedJson(form, $customer);

  // events
  $: $customer && setForm();

  function setForm() {
    setTimeout(()=>{
      form = new Customer($customer);
    })
  }

  function handleSave() {
    asteroid.call("customers.update", id, form);
  }

  function assignToOrder() {
    asteroid.call("orders.setCustomer", currentOrder._id, $customer._id);
  }
</script>

<Modal bgClick={url('customers/index')}>
  <main
    class="relative bg-white p-2 pt-6 sm:p-10 shadow-xl sm:rounded w-full
    sm:w-2/3 md:w-1/2 my-8 mx-auto">

    <div class="text-3xl">
      <input type="text" bind:value={form.name} placeholder="navn" />
    </div>
    <div>
      <input type="text" bind:value={form.address} placeholder="adresse" />
    </div>
    <div>
      <input type="text" bind:value={form.city} placeholder="by" />
    </div>
    <div>
      <input type="text" bind:value={form.postcode} placeholder="postnummer" />
    </div>
    <div>
      <input type="text" bind:value={form.email} placeholder="email" />
    </div>
    <div>
      <input type="text" bind:value={form.phone} placeholder="telefon" />
    </div>
    {#if changes && Object.entries(changes).length}
      <div class="text-right">
        <button class="btn solid green" on:click={handleSave}>Gem</button>
      </div>
    {/if}
    {#if !currentOrder.customerId}
      <button class="outline btn orange" on:click={assignToOrder}>
        Vedhæft aktive ordre
      </button>
    {/if}
    <Orders {id}  {url} {statusOptionsObj}/>
  </main>
</Modal>
